/**
 * Utilitários de autenticação / sessão.
 * Centraliza o acesso ao localStorage para evitar repetição em toda a aplicação.
 */

export const getToken = () => localStorage.getItem('token');

export const getOrgaoId = () => localStorage.getItem('orgao_id');

export const getClienteId = () => localStorage.getItem('cliente_id');
